export const SENTRY_DSN =
  'https://9c2a5667c04040e5be2e61b6ade11fe5@o261284.ingest.sentry.io/5962338'

export const FIREBASE_API_KEY = 'AIzaSyA6WvkYnRq9Mm3BXjYB3ngbZcuh94aj0yI'
export const FIREBASE_AUTH_DOMAIN = 'arriva-klarbuss.firebaseapp.com'
export const API_HOST = 'https://klarbuss-api.reges-services.se'
export const TOKEN_NAME = 'klarbuss_access_token'
